export const NaturePhotos =[
{ "imgUrl":"../pi/l/Nature/n (42).jpg",},
{ "imgUrl":"../pi/l/Nature/n (6).jpg",},
{ "imgUrl":"../pi/l/Nature/n (13).jpg",},
{ "imgUrl":"../pi/l/Nature/n (14).jpg",},
{ "imgUrl":"../pi/p/Nature/n (16).jpg",},
{ "imgUrl":"../pi/l/Nature/n (12).jpg",},
{ "imgUrl":"../pi/l/Nature/n (15).jpg",},
{ "imgUrl":"../pi/l/Nature/n (4).jpg",},
{ "imgUrl":"../pi/p/Nature/n (14).jpg",},
{ "imgUrl":"../pi/l/Nature/n (17).jpg",},
{ "imgUrl":"../pi/l/Nature/n (18).jpg",},
{ "imgUrl":"../pi/l/Nature/n (20).jpg",},
{ "imgUrl":"../pi/p/Nature/n (13).jpg",},
{ "imgUrl":"../pi/l/Nature/n (21).jpg",},
{ "imgUrl":"../pi/l/Nature/n (22).jpg",},
{ "imgUrl":"../pi/l/Nature/n (24).jpg",},
{ "imgUrl":"../pi/p/Nature/n (11).jpg",},
{ "imgUrl":"../pi/l/Nature/n (28).jpg",},
{ "imgUrl":"../pi/l/Nature/n (26).jpg",},
{ "imgUrl":"../pi/l/Nature/n (27).jpg",},
{ "imgUrl":"../pi/p/Nature/n (10).jpg",},
{ "imgUrl":"../pi/l/Nature/n (31).jpg",},
{ "imgUrl":"../pi/l/Nature/n (29).jpg",},
{ "imgUrl":"../pi/l/Nature/n (30).jpg",},
{ "imgUrl":"../pi/p/Nature/n (18).jpg",},
{ "imgUrl":"../pi/l/Nature/n (19).jpg",},
{ "imgUrl":"../pi/l/Nature/n (32).jpg",},
{ "imgUrl":"../pi/l/Nature/n (37).jpg",},
{"imgUrl":"../pi/l/Nature/n (82).jpg"},
{"imgUrl":"../pi/l/Nature/n (33).jpg"},
{"imgUrl":"../pi/l/Nature/n (34).jpg"},
{"imgUrl":"../pi/p/Nature/n (3).jpg"},
{"imgUrl":"../pi/l/Nature/n (39).jpg"},
{"imgUrl":"../pi/l/Nature/n (36).jpg"},
{"imgUrl":"../pi/l/Nature/n (38).jpg"},
{"imgUrl":"../pi/p/Nature/n (4).jpg"},
{"imgUrl":"../pi/l/Nature/n (40).jpg"},
{"imgUrl":"../pi/l/Nature/n (41).jpg"},
{"imgUrl":"../pi/l/Nature/n (35).jpg"},
{"imgUrl":"../pi/p/Nature/n (6).jpg"},
{"imgUrl":"../pi/l/Nature/n (43).jpg"},
{"imgUrl":"../pi/l/Nature/n (44).jpg"},
{"imgUrl":"../pi/l/Nature/n (45).jpg"},
{"imgUrl":"../pi/l/Nature/n (47).jpg"},
{"imgUrl":"../pi/l/Nature/n (63).jpg"},
{"imgUrl":"../pi/l/Nature/n (48).jpg"},
{"imgUrl":"../pi/l/Nature/n (49).jpg"},
{ "imgUrl":"../pi/l/Nature/n (23).jpg",},
{"imgUrl":"../pi/l/Nature/n (64).jpg"},
{"imgUrl":"../pi/l/Nature/n (71).jpg"},
{"imgUrl":"../pi/l/Nature/n (50).jpg"},
{"imgUrl":"../pi/p/Nature/n (19).jpg"},
{"imgUrl":"../pi/l/Nature/n (51).jpg"},
{"imgUrl":"../pi/p/Nature/n (15).jpg"},
{"imgUrl":"../pi/p/Nature/n (9).jpg"},
{"imgUrl":"../pi/l/Nature/n (52).jpg"},
{"imgUrl":"../pi/l/Nature/n (53).jpg"},
{"imgUrl":"../pi/l/Nature/n (54).jpg"},
{"imgUrl":"../pi/p/Nature/n (8).jpg"},
{"imgUrl":"../pi/l/Nature/n (7).jpg"},
{"imgUrl":"../pi/l/Nature/n (70).jpg"},
{"imgUrl":"../pi/l/Nature/n (57).jpg"},
{"imgUrl":"../pi/l/Nature/n (72).jpg"},
{"imgUrl":"../pi/l/Nature/n (84).jpg"},
{"imgUrl":"../pi/l/Nature/n (80).jpg"},
{"imgUrl":"../pi/l/Nature/n (69).jpg"},
{ "imgUrl":"../pi/l/Nature/n (16).jpg",},
{ "imgUrl":"../pi/l/Nature/n (2).jpg",},
{"imgUrl":"../pi/l/Nature/n (66).jpg"},
{"imgUrl":"../pi/p/Nature/n (23).jpg"},
{ "imgUrl":"../pi/p/Nature/n (5).jpg",},
{"imgUrl":"../pi/l/Nature/n (73).jpg"},
{"imgUrl":"../pi/l/Nature/n (68).jpg"},
{"imgUrl":"../pi/l/Nature/n (81).jpg"},
{"imgUrl":"../pi/l/Nature/n (90).jpg"},
{ "imgUrl":"../pi/l/Nature/n (5).jpg",},
{ "imgUrl":"../pi/l/Nature/n (9).jpg",},
{ "imgUrl":"../pi/l/Nature/n (3).jpg",},
{"imgUrl":"../pi/l/Nature/n (77).jpg"},
{"imgUrl":"../pi/l/Nature/n (75).jpg"},
{"imgUrl":"../pi/l/Nature/n (77).jpg"},
{"imgUrl":"../pi/p/Nature/n (26).jpg"},
{"imgUrl":"../pi/p/Nature/n (1).jpg"},
{"imgUrl":"../pi/p/Nature/n (27).jpg"},
{ "imgUrl":"../pi/l/Nature/n (10).jpg",},
{ "imgUrl":"../pi/l/Nature/n (11).jpg",},
{ "imgUrl":"../pi/p/Nature/n (12).jpg",},
{ "imgUrl":"../pi/l/Nature/n (23).jpg",},
{"imgUrl":"../pi/l/Nature/n (63).jpg"},
{"imgUrl":"../pi/l/Nature/n (64).jpg"},
{"imgUrl":"../pi/p/Nature/n (21).jpg"},
{"imgUrl":"../pi/l/Nature/n (65).jpg"},
{"imgUrl":"../pi/l/Nature/n (25).jpg"},
{"imgUrl":"../pi/l/Nature/n (67).jpg"},
{"imgUrl":"../pi/l/Nature/n (76).jpg"},
{"imgUrl":"../pi/l/Nature/n (55).jpg"},
{"imgUrl":"../pi/l/Nature/n (56).jpg"},
{"imgUrl":"../pi/l/Nature/n (78).jpg"},
{"imgUrl":"../pi/p/Nature/n (22).jpg"},
{"imgUrl":"../pi/l/Nature/n (35).jpg"},
{"imgUrl":"../pi/p/Nature/n (7).jpg"},
{ "imgUrl":"../pi/p/Nature/n (2).jpg",},
{ "imgUrl":"../pi/l/Nature/n (1).jpg",},
{"imgUrl":"../pi/l/Nature/n (60).jpg"},
{ "imgUrl":"../pi/p/Nature/n (17).jpg",},
{"imgUrl":"../pi/p/Nature/n (24).jpg"},
{"imgUrl":"../pi/p/Nature/n (28).jpg"},
]